<template>
  <div class="image-container">
    <img 
      src="@/assets/30935_11zon.webp"
      alt="Imagen destacada"
      class="cover-image anim-imagen"
      loading="lazy"
      decoding="async"
    >
    
    <!-- Capa de oscurecimiento sutil inferior -->
    <div class="overlay anim-overlay"></div>
    
    <!-- Texto de firma -->
    <div class="text-overlay anim-texto">
      <p class="firma">
        Con cariño,<br>
        <span class="nombre-firma">Angie Urbina</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoverImageComponent'
}
</script>

<style scoped>
.image-container {
  width: 100%;
  height: 590px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  contain: content; /* Aísla los cálculos de pintado */
}

.cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}

/* Oscurecimiento inferior */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 40%,
    rgba(0, 0, 0, 0.65) 100%
  );
  z-index: 2;
}

.text-overlay {
  position: relative;
  z-index: 10;
  width: 100%;
  text-align: center;
  color: #ffffff;
  padding: 0 20px 32px;
  box-sizing: border-box;
}

/* ANIMACIONES NATIVAS DE GPU */
.anim-imagen {
  animation: entradaImagen 0.5s ease-out forwards;
  will-change: transform, opacity;
  backface-visibility: hidden;
}

.anim-overlay {
  animation: fadeIn 0.5s ease-out forwards;
  will-change: opacity;
}

.anim-texto {
  animation: entradaTexto 0.5s ease-out forwards;
  animation-delay: 0.15s; /* Entrada escalonada ligera */
  will-change: transform, opacity;
  backface-visibility: hidden;
}

@keyframes entradaImagen {
  0% {
    opacity: 0;
    transform: translate3d(0, 15px, 0);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes entradaTexto {
  0% {
    opacity: 0;
    transform: translate3d(0, 15px, 0);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeIn {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

.firma {
  font-size: 16px;
  font-family: 'Josefin Sans', sans-serif;
  font-weight: 300;
  letter-spacing: 2px;
  line-height: 1.4;
  margin: 0;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
}

.nombre-firma {
  display: block;
  margin-top: 8px;
  font-family: 'CynthiaJuneJF', cursive;
  font-size: 52px;
  color: #ffffff;
  line-height: 1.1;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
}

@media (max-width: 480px) {
  .image-container {
    height: 520px;
  }
  .nombre-firma {
    font-size: 44px;
  }
}
</style>